import styled from "styled-components";
import { Diversity1Outlined } from "@mui/icons-material";

interface ResponsiveProps {
  $isPhone?: boolean;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalBox = styled.div<ResponsiveProps>`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "782px")};
  max-width: 100%;
  text-align: center;
  direction: rtl;
`;

export const ModalTitle = styled.h2<ResponsiveProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "1.25rem" : "1.5rem")};
  font-weight: 700;
  color: #331860;
`;

export const ModalDescription = styled.p<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "508px")};
  font-size: ${({ $isPhone }) => ($isPhone ? "0.875rem" : "1rem")};
  font-weight: 400;
  color: #625783;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e2e8f0;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "flex-end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background: white;
  padding-inline: 32px;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width || "auto"};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }
`;

export const CloseButtonContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 64px;
  cursor: pointer;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
`;

export const ContentWrapper = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 782px;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "381px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
  padding-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
`;

export const StyledAirbnbIcon = styled(Diversity1Outlined)<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "120px" : "160px")};
  height: ${({ $isPhone }) => ($isPhone ? "56px" : "74px")};
`;
